// extracted by mini-css-extract-plugin
export default {"wrapper":"M1XDZSD","container":"AQMTh7M","title":"OGdaCNb","posts-box":"gSci2Jt","postsBox":"gSci2Jt","posts-slider":"lWaiwKZ","postsSlider":"lWaiwKZ"};